var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display-options-container rounded-pill white d-flex align-center justify-space-between h-100 position-relative elevation-1"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }